export default __webpack_public_path__ + "static/media/Body_C5.4dcafa52.svg";